import React from 'react';

type BrandConnectIconProps = {
  stroke?: string;
};

export function BrandConnectIcon({ stroke = 'var(--color-gray-70)' }: BrandConnectIconProps) {
  return (
    <svg
      className='stroke-overrides'
      fill='none'
      height='24'
      viewBox='0 0 24 24'
      width='24'
      xmlns='http://www.w3.org/2000/svg'
    >
      <defs>
        <clipPath id='brandConnectClip'>
          <rect fill='white' height='24' width='24' />
        </clipPath>
      </defs>
      <g clipPath='#brandConnectClip'>
        <path
          d='M11.25 18C11.25 18.5967 11.4871 19.169 11.909 19.591C12.331 20.0129 12.9033 20.25 13.5 20.25C14.0967 20.25 14.669 20.0129 15.091 19.591C15.5129 19.169 15.75 18.5967 15.75 18C15.75 17.4033 15.5129 16.831 15.091 16.409C14.669 15.9871 14.0967 15.75 13.5 15.75C12.9033 15.75 12.331 15.9871 11.909 16.409C11.4871 16.831 11.25 17.4033 11.25 18Z'
          stroke={stroke}
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='1.5'
        />
        <path
          d='M18.75 21C18.75 21.5967 18.9871 22.169 19.409 22.591C19.831 23.0129 20.4033 23.25 21 23.25C21.5967 23.25 22.169 23.0129 22.591 22.591C23.0129 22.169 23.25 21.5967 23.25 21C23.25 20.4033 23.0129 19.831 22.591 19.409C22.169 18.9871 21.5967 18.75 21 18.75C20.4033 18.75 19.831 18.9871 19.409 19.409C18.9871 19.831 18.75 20.4033 18.75 21Z'
          stroke={stroke}
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='1.5'
        />
        <path
          d='M18.75 13.5C18.75 14.0967 18.9871 14.669 19.409 15.091C19.831 15.5129 20.4033 15.75 21 15.75C21.5967 15.75 22.169 15.5129 22.591 15.091C23.0129 14.669 23.25 14.0967 23.25 13.5C23.25 12.9033 23.0129 12.331 22.591 11.909C22.169 11.4871 21.5967 11.25 21 11.25C20.4033 11.25 19.831 11.4871 19.409 11.909C18.9871 12.331 18.75 12.9033 18.75 13.5Z'
          stroke={stroke}
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='1.5'
        />
        <path
          d='M15.425 16.8453L19.075 14.6553'
          stroke={stroke}
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='1.5'
        />
        <path
          d='M15.588 18.835L18.912 20.165'
          stroke={stroke}
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='1.5'
        />
        <path
          d='M12 23.25C9.93765 23.2494 7.91516 22.6819 6.15356 21.6095C4.39196 20.5371 2.95903 19.0011 2.01139 17.1694C1.06374 15.3376 0.637845 13.2807 0.780239 11.2233C0.922632 9.16583 1.62784 7.18714 2.81879 5.50343C4.00973 3.81971 5.64059 2.49577 7.53313 1.67628C9.42567 0.856797 11.5071 0.573308 13.5498 0.856798C15.5926 1.14029 17.5181 1.97985 19.116 3.28372C20.7138 4.5876 21.9225 6.30561 22.61 8.25'
          stroke={stroke}
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='1.5'
        />
        <path
          d='M9.289 22.9211C7.768 20.6891 6.75 16.6331 6.75 12.0001C6.75 7.3671 7.768 3.3121 9.289 1.0791'
          stroke={stroke}
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='1.5'
        />
        <path d='M2.99899 5.25H21' stroke={stroke} strokeLinecap='round' strokeLinejoin='round' strokeWidth='1.5' />
        <path d='M2.048 17.25H8.25' stroke={stroke} strokeLinecap='round' strokeLinejoin='round' strokeWidth='1.5' />
        <path
          d='M14.711 1.0791C16.148 3.1871 17.135 6.9221 17.241 11.2331V11.2501H0.774994'
          stroke={stroke}
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='1.5'
        />
      </g>
    </svg>
  );
}
